import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './ComicScript.module.css';
import Script1PDF from '../../images/Script-1.pdf';
import Script2PDF from '../../images/Script-2.pdf';
import Script1 from '../../images/comic-script-1.jpg';
import Script2 from '../../images/Panel-1.jpg';
import Script3 from '../../images/Panel-2.jpg';
import Script4 from '../../images/Panel-3.jpg';
import Script5 from '../../images/The-Midnight-Snack-Monster.jpg';
import Script6 from '../../images/story-1.jpg';
import Script7 from '../../images/story-2.jpg';
import Script8 from '../../images/story-3.jpg';
import Script9 from '../../images/story-4.jpg';
import Script10 from '../../images/story-5.jpg';
import Script11 from '../../images/story-6.jpg';
import Script12 from '../../images/story-7.jpg';

const scriptAssets = {
  1: { pdf: Script1PDF, images: [Script2, Script3, Script4] },
  2: { pdf: Script2PDF, images: [Script6, Script7, Script8, Script9, Script10, Script11, Script12] }
};

const ScriptDetailPage = () => {
  const location = useLocation();
  const scriptData = location.state || {
    id: 1,
    title: "A Tiny Bite of Kindness",
    subtitle: "Tiny Bite, Big Kindness",
    description: "A small ant is saved by a dove, and later the ant returns the favor by protecting the dove from danger.",
    image: Script1
  };
  
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const currentImages = scriptAssets[scriptData.id]?.images || scriptAssets[1].images;
  const imagesPerSlide = isMobile ? 1 : (currentImages.length > 3 ? 3 : 1);
  const totalSlides = Math.ceil(currentImages.length / imagesPerSlide);

  const handleImageClick = (img, index) => {
    setSelectedImage(img);
    setSelectedImageIndex(index);
  };

  const handlePrevImage = () => {
    const newIndex = selectedImageIndex > 0 ? selectedImageIndex - 1 : currentImages.length - 1;
    setSelectedImageIndex(newIndex);
    setSelectedImage(currentImages[newIndex]);
  };

  const handleNextImage = () => {
    const newIndex = selectedImageIndex < currentImages.length - 1 ? selectedImageIndex + 1 : 0;
    setSelectedImageIndex(newIndex);
    setSelectedImage(currentImages[newIndex]);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, [currentImages.length]);



  const handleExport = () => {
    const assets = scriptAssets[scriptData.id] || scriptAssets[1];
    const link = document.createElement('a');
    link.href = assets.pdf;
    link.download = `Script-${scriptData.id}.pdf`;
    link.click();
  };

  const handleShare = (platform) => {
    const url = window.location.href;
    const text = encodeURIComponent(`Check out this amazing comic script: ${scriptData.title}`);
    const shareUrls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${url}`,
      instagram: `https://www.instagram.com/`
    };
    window.open(shareUrls[platform], '_blank', 'width=600,height=600');
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />

      <div className={styles.scriptDetailPage}>
        {/* Background */}
        <div className={styles.detailBg} style={{
          backgroundImage: `url(${scriptData.image})`,
          filter: 'blur(5px) brightness(0.4)'
        }}>
          <div className={styles.detailParticles}>
            {[...Array(25)].map((_, i) => (
              <div key={i} className={styles.bgParticle} style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 20}s`,
                animationDuration: `${15 + Math.random() * 10}s`
              }} />
            ))}
          </div>
        </div>

        {/* Header */}
        <div className={styles.detailHeader}>
          <div className={styles.headerContent}>
            <button className={styles.backBtn} onClick={() => window.history.back()}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
              Back to Scripts
            </button>
            <div className={styles.titleWrapper}>
              <h1 className={styles.detailTitle}>{scriptData.title}</h1>
              <h2 className={styles.detailSubtitle}>{scriptData.subtitle}</h2>
            </div>
          </div>
        </div>

        {/* Flip Book + Sidebar */}
        <div className={styles.detailContent}>
          <div className={styles.scriptSection}>
            <div className={styles.carouselSection}>
              <div className={styles.carouselContainer}>
                <button className={styles.carouselBtn} onClick={prevSlide}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </button>
                
                <div className={styles.carouselWrapper}>
                  <div 
                    className={styles.carouselTrack}
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                      <div key={slideIndex} className={styles.carouselSlideGroup}>
                        {currentImages.slice(slideIndex * imagesPerSlide, (slideIndex + 1) * imagesPerSlide).map((img, imgIndex) => (
                          <div 
                            key={slideIndex * imagesPerSlide + imgIndex} 
                            className={`${styles.carouselSlide} ${imagesPerSlide === 1 ? styles.carouselSlideSingle : ''}`}
                            onClick={() => handleImageClick(img, slideIndex * imagesPerSlide + imgIndex)}
                          >
                            <img src={img} alt={`${scriptData.title} page ${slideIndex * imagesPerSlide + imgIndex + 1}`} className={styles.carouselImage} />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
                
                <button className={styles.carouselBtn} onClick={nextSlide}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              </div>
              
              <div className={styles.pagination}>
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <button
                    key={index}
                    className={`${styles.dot} ${index === currentSlide ? styles.dotActive : ''}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div className={styles.sidebar}>
              <div className={styles.sidebarCard}>
                <h3 className={styles.sidebarTitle}>Actions</h3>
                <div className={styles.actionsList}>
                  <button onClick={handleExport} className={styles.actionBtnSecondary}>
                    Export PDF
                  </button>
                  <button onClick={() => setShowShareModal(true)} className={styles.actionBtnSecondary}>
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Share Modal */}
      {showShareModal && (
        <div className={styles.modalOverlay} onClick={() => setShowShareModal(false)}>
          <div className={styles.shareModal} onClick={e => e.stopPropagation()}>
            <button className={styles.closeBtn} onClick={() => setShowShareModal(false)}>×</button>
            <h3>Share This Script</h3>
            <div className={styles.shareButtons}>
              <button onClick={() => handleShare('facebook')} className={styles.shareBtn}>Facebook</button>
              <button onClick={() => handleShare('instagram')} className={styles.shareBtn}>Instagram</button>
              <button onClick={() => handleShare('linkedin')} className={styles.shareBtn}>LinkedIn</button>
              <button onClick={() => handleShare('whatsapp')} className={styles.shareBtn}>WhatsApp</button>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {selectedImage && (
        <div className={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
          <div className={styles.imageModalContent} onClick={e => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={() => setSelectedImage(null)}>×</button>
            
            <button className={styles.navBtn} onClick={handlePrevImage}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            
            <img src={selectedImage} alt="Script page" className={styles.modalImage} />
            
            <button className={styles.navBtn} onClick={handleNextImage}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            
            <div className={styles.imageCounter}>
              {selectedImageIndex + 1} / {currentImages.length}
            </div>
          </div>
        </div>
      )}

      <Footer mode={mode} />
    </>
  );
};

export default ScriptDetailPage;